<div [ngTemplateOutlet]="selected?.content"></div>
<div [class.hide]="hideWrapper" [ngClass]="['content ', goStepperClass]" class="steps-wrapper" *ngIf="!hideStepsIndicator">
		<span class="step" *ngFor="let step of steps; let i = index" [ngClass]="{'is-active': isSelected(i), 'hide': step.hideIndicator}"></span>
</div>
